const $year = document.querySelector('.timer__year');
const $month = document.querySelector('.timer__month');
const $days = document.querySelector('.timer__days');
const $hours = document.querySelector('.timer__hours');
const $minutes = document.querySelector('.timer__minutes');
const $seconds = document.querySelector('.timer__seconds');

if ($hours) {
  function getNextDeadline() {
    const now = new Date();
    const todayAt17 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0);

    // Если сейчас уже после 17:00, устанавливаем дедлайн на следующий день в 17:00
    if (now >= todayAt17) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 17, 0, 0);
    }
    return todayAt17;
  }

  let deadline = getNextDeadline();
  let timerId = null;

  function declensionNum(num, words) {
    return words[(num % 100 > 4 && num % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(num % 10 < 5) ? num % 10 : 5]];
  }

  function countdownTimer() {
    const now = new Date();
    let diff = deadline - now;

    if (diff <= 0) {
      deadline = getNextDeadline(); // Установить дедлайн на следующий день
      diff = deadline - now;
    }

    const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
    const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
    const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
    const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;

    $days.textContent = days < 10 ? '0' + days : days;
    $hours.textContent = hours < 10 ? '0' + hours : hours;
    $minutes.textContent = minutes < 10 ? '0' + minutes : minutes;
    $seconds.textContent = seconds < 10 ? '0' + seconds : seconds;

    $days.dataset.title = declensionNum(days, ['день', 'дня', 'дней']);
    $hours.dataset.title = declensionNum(hours, ['час', 'часа', 'часов']);
    $minutes.dataset.title = declensionNum(minutes, ['минута', 'минуты', 'минут']);
    $seconds.dataset.title = declensionNum(seconds, ['секунда', 'секунды', 'секунд']);
  }

  if ($days !== null) {
    countdownTimer();
    timerId = setInterval(countdownTimer, 1000);
  }
}
